import { useMutation } from "@apollo/client/react";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { CERRAR_PERIODO } from "../../../data/graphQL/mutations/Periodos/cerrarPeriodo";
import toast from "react-hot-toast";

export const CerrarPeriodoDialog = ({
  idPeriodo,
  open,
  onClose,
  getPeriodos
}) => {
  const handleClose = () => {
    onClose();
  };

  const [cerrarPeriodo, { cerrarLoading }] = useMutation(CERRAR_PERIODO, {
    fetchPolicy: 'no-cache',
    variables: { idPeriodo }
  });

  const handleClickAceptar = async () => {
    try {
      await toast.promise(
        cerrarPeriodo(), {
          loading: 'Cerrando periodo...',
          success: 'Periodo cerrado.',
          error: 'Ocurrió un error al intentar cerrar el periodo.'
        }
      );
      await getPeriodos();
    } catch (error) {
      toast.error('Error al cerrar el periodo.');
    } finally {
      handleClose();
    }
  };

  return (
    <CustomDialog
      maxWidth='lg'
      fullWidth
      onCancel={() => handleClose()}
      onAccept={() => handleClickAceptar()}
      acceptLoading={cerrarLoading}
      open={open}
      cancelText='Cancelar'
      acceptText='Aceptar'
      title={'Cerrar periodo'}>
      
            <span>¿Esta seguro que desea cerrar el periodo actual?</span>
        </CustomDialog>);

};